import { render, staticRenderFns } from "./AddRemDtList.vue?vue&type=template&id=ae4b1db6&scoped=true&"
import script from "./AddRemDtList.vue?vue&type=script&lang=js&"
export * from "./AddRemDtList.vue?vue&type=script&lang=js&"
import style0 from "./AddRemDtList.vue?vue&type=style&index=0&id=ae4b1db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4b1db6",
  null
  
)

export default component.exports